<template lang="pug">
  #people-show.grid-scroll-more(v-if="!loading")
    #ps-info
      #ps-left
        #ps-name {{ person.fullName}}
        #ps-bio {{ person.bio }}
        #ps-links
          #ps-location.icon-wrap(v-if="person.location")
            icon(data="~@/assets/svg/map-pin.svg" :fill="false")
            span {{ person.location }}

          a#ps-twitter(v-if="person.showTwitterUrl" :href="person.twitterUrl" title="Twitter Link" target="_blank" rel="nofollow noopener" @click.stop)
            icon(data="~@/assets/svg/twitter.svg" :fill="false")
            span {{ twitterUsername }}

          a#ps-website(v-if="person.website" :href="person.website" title="Website Link" target="_blank" rel="nofollow noopener" @click.stop)
            icon(data="~@/assets/svg/globe.svg" :fill="false")
            span {{ websiteHost }}

      #ps-right
        #ps-likes-count {{person.likesCount}} {{ 'Like' | pluralize('Likes', person.likesCount) }}

        SortByMenu(@sortBy="setSortOrder" :sortOptions="sortOptions" placement="bottom-end")

    GridDisplay(:entities="interests")
      ImgBlock(:user="person")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {},

  data() {
    return {
      person: null,
      loading: true,
      sortOrder: 'recent',
      sortOptions: ['recent', 'most visited'],
    }
  },

  channels: {
    UserChannel: {
      connected() {},
      rejected() {},
      received(data) {
        console.log('PeopleShow.vue :49', data)
        if (this.sortOrder == 'recent') {
          this.$store.commit('interests/ADD_OR_UPDATE', data)
        } else {
          this.$store.commit('interests/UPDATE', data)
        }
      },
      disconnected() {},
    },
  },

  computed: {
    ...mapGetters({
      findByUsername: 'users/findByUsername',
      sortBy: 'interests/sortBy',
    }),
    interests,
    twitterUsername,
    websiteHost,
  },

  watch: {},

  methods: {
    fetchInterests,
    setSortOrder,
  },

  async created() {
    await this.$store.dispatch('users/fetchSingle', this.$route.params.slug)

    this.person = this.findByUsername(this.$route.params.slug)

    this.$cable.subscribe({ channel: 'UserChannel', id: this.person.id })
    await this.fetchInterests()

    this.loading = false
  },

  components: {
    GridDisplay: require('@/components/GridDisplay').default,
    ImgBlock: require('@/components/ImgBlock').default,
    SortByMenu: require('@/components/SortByMenu').default,
    PageHeader: require('@/components/PageHeader').default,
  },
}

/* Computed ---------------------------------------------------- */
function interests() {
  return this.sortBy(this.sortOrder)
}

function twitterUsername() {
  return this.person.twitterUrl?.split('/').slice(-1)[0]
}

function websiteHost() {
  return this.person.website?.match(/(?!(w+)\.)\w*(?:\w+\.)+\w+/g)[0]
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
async function fetchInterests() {
  await this.$store.dispatch('users/fetchInterests', {
    username: this.person.username,
    sort: this.sortOrder,
  })
}

function setSortOrder(order) {
  this.sortOrder = order
  this.fetchInterests()
}
</script>
